import React from "react";
import styled, { css } from "styled-components";

import { MenuWidth } from "src/context/SideBarContext/utils";
import { breakpoint } from "src/library/utils/styled-media-queries/index";

type FixedBottomMenuWrapperProps = { active: boolean; $fullscreen?: boolean; };

/**
 * A wrapper for a fixed position menu view that appears at the bottom of page
 *
 * @returns a horizontal menu react element
 */
export const FixedBottomMenuWrapper: React.ReactFCWithChildren<FixedBottomMenuWrapperProps> = ({
  children, active, $fullscreen
}) => {
  return (
    <MenuWrapper
      $fullscreen={$fullscreen}
      className={!active ? "inactive" : undefined}
    >
      <MenuContainer $fullscreen={$fullscreen}>
        {children}
      </MenuContainer>
    </MenuWrapper>
  );
};

const MenuWrapper = styled.div<{$fullscreen?: boolean;}>`
  ${({ theme, $fullscreen }) => css`
    position: fixed;
    bottom: 35px;
    display: flex;
    justify-content: center;
    transition: ${theme.transition.quick};

    ${$fullscreen ? css`
      left: 50%;
      transform: translateX(-50%);
    ` : ""}
  
    &.inactive {
      opacity: 0;
      transform: translate(0, 100px);
      pointer-events: none;
    }
  `}
`;

const MenuContainer = styled.div<{ $fullscreen?: boolean; }>`
  ${({ theme, $fullscreen }) => css`
    background: ${theme.colors.lightestGrey};
    width: calc(100vw - (2 * ${theme.spacing.padding.sm}));
    border-radius: ${theme.borderRadius};
    box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.25);
    padding: ${theme.spacing.padding.sm} ${theme.spacing.padding.md};
    
    ${breakpoint("md", theme)} {
      width: calc(100vw - ${MenuWidth}px - (2 * (${theme.spacing.padding.sm} + ${theme.spacing.padding.lg})));
    }

    ${$fullscreen ? css`
      width: calc(100% - (2 * (${theme.spacing.padding.sm} + ${theme.spacing.padding.lg})));
    ` : ""}
  `}
`;
